<template>
    <div>
        <risk-assessment-view isOnboarding v-if="item.name == 'view'" />
        <risk-assessment-process isOnboarding v-else-if="item.name == 'process'" />
    </div>
</template>

<script>
    import RiskAssessmentView from '@pages/dashboard/service/risk-assessment/view'
    import RiskAssessmentProcess from '@pages/dashboard/service/risk-assessment/process'
    export default {
        name: "m-onboard-riskassessment",
        components: {
            RiskAssessmentView,
            RiskAssessmentProcess
        },
        props: {
            item: {
                type: Object
            }
        }
    }
</script>

<style scoped>

</style>